import { RootState } from '../'

export const selectTestMode = (state: RootState) => state.testMode
